import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { goToNextPage } from 'src/app/common/common';
import { SystemPropertiesViewModel } from 'src/app/model/systemPropeties.model';
import { AuthService } from 'src/app/services/auth.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-system-properties-index',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './system-properties-index.component.html',
  styleUrl: './system-properties-index.component.scss'
})
export class SystemPropertiesIndexComponent implements OnInit {
  public isAdmin: boolean = false;
  public displayedProps: SystemPropertiesViewModel[] = [];
  public error: string | null = null;
  public router: Router;

  constructor(
    private injector: Injector,
    private authService: AuthService,
    private systemPropertiesService: ApiService
  ) {
    this.router = injector.get(Router);
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.checkAuthorization();
    this.loadSystemProperties();
  }

  loadSystemProperties() {
    this.systemPropertiesService.getSystemProperties(1).subscribe({
      next: (response: any) => {
        this.displayedProps = response.map((props: any) => props);
      },
      error: (err) => {
        console.error(err);
        this.error = err;
      }
    });
  }

  nextPage(event: any, url: string, router: Router) {
    return goToNextPage(event, url, router);
  }

  delete(prop: any) {
    if (confirm('Are you sure you want to delete this system property?')) {
      this.systemPropertiesService.deleteSystemProperties(prop.key).subscribe({
        next: () => {
          this.loadSystemProperties();
        },
        error: (err) => {
          console.error(err);
          this.error = err;
        }
      });
    }
  }
}
